import type { TaskStatus } from "@/modules/management/project/domain/types";

/** ແທ່ງ progress ວຽກຍ່ອຍ — ຄູ່ກັບ taskStatusClass ໃນ ProjectDetailTasksTab */
export function taskStatusProgressFillClass(status: TaskStatus): string {
  switch (status) {
    case "in_progress":
      return "bg-blue-600 dark:bg-blue-500";
    case "done":
      return "bg-green-600 dark:bg-green-500";
    case "pending":
    default:
      return "bg-muted-foreground/55 dark:bg-muted-foreground/50";
  }
}

export function taskStatusProgressPercentTextClass(
  status: TaskStatus,
): string {
  switch (status) {
    case "in_progress":
      return "text-blue-700 dark:text-blue-300";
    case "done":
      return "text-green-700 dark:text-green-300";
    case "pending":
    default:
      return "text-muted-foreground";
  }
}
